module.exports = __webpack_public_path__ + "img/slide5.1dcf3aa8.jpg";